import "./styles/App.css";
import Root from "./components/Root";
import Auth from "./components/Auth";
import { Route, Routes } from "react-router";
import { useEffect } from "react";
import { onAuthStateChanged } from "firebase/auth";
import {
  auth,
  getConfigFromFirestore,
  validateUserInFireDb,
} from "./services/firebase";
import { useNavigate } from "react-router";
import { useDispatch } from "react-redux";
import { setDataThunk, setInitialState } from "./services/store";
import Demo from "./lib/Demo";

function App() {
  const navigate = useNavigate();
  const dispatch = useDispatch();

  useEffect(() => {
    onAuthStateChanged(auth, async (user) => {
      if (user) {
        await validateUserInFireDb();
        const userConfig = await getConfigFromFirestore();
        dispatch(setInitialState(userConfig));
        dispatch(setDataThunk(userConfig.data)); // retain multipage or listicle on refresh
      } else {
        navigate("/auth");
      }
    });
  }, []);

  return (
    <div className="App">
      <Routes>
        <Route path="/" element={<Root />} />
        <Route path="/home" element={<Root />} />
        <Route path="/auth" element={<Auth />} />
      </Routes>
      <Demo />
    </div>
  );
}

export default App;
